module.exports = __webpack_public_path__ + "static/img/icon_regression.fb26af90.svg";